import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableDataSetField } from '@/models/tableDataset/TableDataSetField';

import SettingsReportField from '@/components/settingsreport/settingsreportfield/SettingsReportField.vue';
import { LoggerService } from '@/utils/index';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';

@Component({
    components: {
        SettingsReportField,
    },
    name: 'SettingsReportValuesComponent',
})
export default class SettingsReportValuesComponent extends Vue {
    @PropSync('data', { type: Array }) public syncedData!: TableDataSetField[];
    @PropSync('titleId', { type: String }) public syncedTitleId!: string;
    @PropSync('titleIndex', { type: Number }) public syncedTitleIndex!: number;
    @PropSync('isSub', { type: Boolean }) public syncedIsSub!: boolean;
    @PropSync('empty', { type: Boolean }) public syncedEmpty!: boolean;


    public singleFields: TableDataSetField[] = [];
    public subFields: TableDataSetField[] = [];


    // tslint:disable-next-line: no-empty
    public mounted() {
        LoggerService.LogDebug(`SettingsReportValuesComponent: `, this.syncedData, this.syncedTitleId);
        this.splitData(this.syncedData);
    }

    @Watch('syncedData', { deep: true })
    public onSyncedDataSetIdChanged(newValue: TableDataSetField[]) {
        if (newValue != null) {
            this.splitData(newValue);
        }
    }

    public splitData(inData: TableDataSetField[]) {
        this.singleFields.splice(0, this.singleFields.length);
        this.subFields.splice(0, this.subFields.length);
        inData.forEach((field) => {
            if ((field.type === FieldTypeEnum.ACTION_SUBFIELD || field.type === FieldTypeEnum.SUBFIELD)
                && field.fields != null) {
                this.subFields.push(field);
            } else {
                this.singleFields.push(field);
            }
        });
    }

    public getClassTitle(): string {
        let classes = '';
        classes += this.syncedIsSub === true ? 'title font-weight-regular sub' : 'headline';
        return classes;
    }

}
